// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 36) return "static/chunks/36-e6c5b1265a108051.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"33":"2f0b94e8","316":"ad2866b8","501":"bc98253f","930":"164f4fb6"}[chunkId] || chunkId) + "." + {"33":"dca94cec8332d372","199":"451237dab205f44a","241":"903272b3bfe9bbbf","312":"290947d6120163ea","316":"2cf0d2625664d51a","501":"7e63d871e474c3ee","894":"0c1d4f6ff58babf7","930":"5113dd73f7fbdc90"}[chunkId] + ".js";
};